import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function start (filialId) {
    return axios.post(`${CRM_API_URL}/administrator/terminal-settlement`, null, { params: { filialId } }).then(response => response.data)
}

function fetch (filialId, commandId) {
    return axios.get(`${CRM_API_URL}/administrator/terminal-settlement/${commandId}`, { params: { filialId } }).then(response => response.data)
}

export default { start, fetch }
